<template>
  <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">
    <md-card class="">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>folder</md-icon>
        </div>
        <h4 class="title">{{ data.label }}</h4>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-layout-data">
            <md-table class="">
              <md-table-row v-for="(row, rowIndex) in files" :key="rowIndex">
                <md-table-cell
                  >{{ row["field_name"] }} - {{ row["name"] }}
                </md-table-cell>
                <md-table-cell>
                  <md-button
                    :disabled="disabled"
                    native-type="button"
                    @click.native.prevent="downloadFile(row)"
                    class="md-success md-button-full-size md-sm"
                  >
                    Download</md-button
                  >
                </md-table-cell>
              </md-table-row>
              <md-table-row v-if="files.length === 0">
                <md-table-cell
                  >Deze widget heeft geen data om weer te geven.</md-table-cell
                >
              </md-table-row>
            </md-table>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      disabled: false
    };
  },
  props: ["data"],
  computed: {
    files: function() {
      if (this.data.data.length === 0) {
        return [];
      }

      return this.data.data[0].fields;
    }
  },
  methods: {
    formatDate(date) {
      if (typeof date !== "string") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("‑");
    },
    downloadFile(data) {
      this.notifyVue(
        "Download van bestand '" + data.name + "' gestart",
        "check",
        "success",
        5000
      );
      this.disabled = true;
      this.$http
        .get(
          this.$apiBaseUrl + "driver/file/" + data.field_id + "/" + data.id,
          {
            responseType: "blob"
          }
        )
        .then(response => {
          this.disabled = false;
          const filename = response.headers.map["content-disposition"][0]
            .split(";")[1]
            .split("filename")[1]
            .split("=")[1]
            .trim()
            .replaceAll('"', "");
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fURL = document.createElement("a");

          fURL.href = fileURL;
          fURL.setAttribute("download", filename);
          document.body.appendChild(fURL);
          fURL.click();
          document.body.removeChild(fURL);
        });
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-layout-data {
  max-height: 200px;
  overflow-y: auto;
}
</style>
